// extracted by mini-css-extract-plugin
export default {"TouchContainer":"TouchContainer_TouchContainer__iZ-5R"};